<template>
  <div>
    <h3>Invoices</h3>

    <b-table
      :items="items"
      :fields="fields"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :current-page="currentPage"
      :per-page="perPage"
      responsive="sm"
      striped
    >
      <template #cell(datetime)="{ item }">
        {{ item.datetime | date }}
      </template>

      <template #cell(amount)="{ item }">
        {{ (item.amount / 100) | currency }}
      </template>

      <template #cell(status)="{ item }">
        <b-badge :variant="invoiceBadge(item.status)">
          {{ item.status }}
        </b-badge>
      </template>

      <template #cell(invoice)="{ item }">
        <b-link v-if="item.pdf" :href="item.pdf" download>
          <i class="icon-cloud-download"></i>
        </b-link>
      </template>

      <template #cell(receipt)="{ item }">
        <b-link v-if="item.receipt" :href="item.receipt" target="_blank">
          view
        </b-link>
      </template>
    </b-table>
    <nav>
      <b-pagination
        v-if="items.length > perPage"
        v-model="currentPage"
        :total-rows="items.length"
        :per-page="perPage"
        align="center"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array
    }
  },

  data: () => ({
    fields: [
      { key: "number", label: "Reference #" },
      { key: "datetime", label: "Date", sortable: true },
      { key: "amount", sortable: true },
      { key: "status", sortable: true, class: "text-center" },
      { key: "invoice", class: "text-center" },
      { key: "receipt", class: "text-center" }
    ],
    currentPage: 1,
    sortBy: "datetime",
    sortDesc: true,
    perPage: 50
  }),

  methods: {
    invoiceBadge(status) {
      switch (status) {
        case "paid":
          return "success";
        case "forgiven":
        case "refund":
        case "upcoming":
          return "secondary";
        default:
          return "warning";
      }
    }
  }
};
</script>

<style></style>
